// @ts-nocheck
import PushNotification from 'react-native-push-notification';
import {deriveDisplayName} from '../utils/deriveDisplayName';
import {store} from '../redux/store';
import {fetchLinksByPerson, updateUnitPeopleLink} from '../api/links';
import {
  HandleAlertButton,
  NavigateToDetails,
  ReceiveAlert,
  DeleteAllAlerts,
  GetAlerts,
} from '../modules/Alerts/alertsReducer';
import {showErrorMessage} from './flashMessage';
import {fetchPerson} from '../api/people';
import {fetchUnitById} from '../api/units';
import {createAlert, sendAction} from '../api/alert';
import {createDateFrame, updatePersonDateFrames} from '../api/dataframe';
import {Alert} from '../@types';
import {UnitLink} from '../@types/UnitLink';
import {Platform, Vibration, AppState} from 'react-native';
import {NavigateToApprovalDetails, DeleteAllApprovals, GetApprovals} from '../redux/reducers/approvalsReducer';
import {GetUnitScreenData} from '../modules/Units/unitsReducer';
import {GetPeople} from '../modules/People/peopleReducer';
import buildAlertObject from '../utils/buildAlertObject';
import {isOneDayDateFrame} from '../utils';
import {sendNotification} from './sendNotification';
import * as Device from 'expo-device';
import { queryClient } from '../config/queryClient';

const configureNotifications = () => {
  PushNotification.configure({
    onRegister: function (token) {
      console.log('TOKEN:', token);
    },
    onNotification: function (notification) {
      console.log('NOTIFICATION:-++++++++++', notification);

      // Handle Pushy notifications that arrive via RNPushNotification's FCM listener.
      // When the app is backgrounded, RNPushNotificationListenerService intercepts the
      // FCM message before Pushy's own PushReceiver. The Pushy payload is wrapped in
      // _pushyPayload as a JSON string. We detect it here and route to the Pushy handler.
      if (notification.data?._pushyPayload && !notification.foreground) {
        try {
          const pushyData = JSON.parse(notification.data._pushyPayload);
          console.log('[RNPush→Pushy] Background Pushy notification detected, routing to handler:', pushyData.EventName);
          handlePushyIncomingNotification(pushyData);
        } catch (err) {
          console.error('[RNPush→Pushy] Failed to parse _pushyPayload:', err);
        }
        return;
      }

      if (notification.data) {
        if (notification.action) {
          const action = notification.action;

          if (notification.data.actions) {
            const response = parseInt(notification.data.actions[action], 10);
            store.dispatch(
              HandleAlertButton(notification.data, action, response),
            );
          }
        } else if (notification.userInteraction) {
          console.log('NOTIFICATION CLICKED WITH DATA:', notification.data);
          if (Platform.OS === 'android') {
            store.dispatch(NavigateToDetails(notification.data.id));
          } else if (Platform.OS === 'ios') {
            const data = notification.data;
            if (data.EventName === 'UnitLink' || data.EventName === 'RequestAccess') {
              if (data.Approval && data.Approval.Id) {
                store.dispatch(NavigateToApprovalDetails(data.Approval.Id));
              }
            } else if (data.AlertId || data.id) {
              store.dispatch(NavigateToDetails(data.AlertId || data.id));
            }
          }
        }
      }

      if (Platform.OS === 'ios') {
        const PushNotificationIOS = require('@react-native-community/push-notification-ios').default;
        notification.finish(PushNotificationIOS.FetchResult.NoData);
      }
    },
    permissions: {
      alert: true,
      badge: true,
      sound: true,
    },

    popInitialNotification: true,
    requestPermissions: Platform.OS === 'ios',
  });
};

export const buildResponseAlert = async (
  notif: Alert,
  response: number,
  eventName: string,
  receiverType: string,
) => {
  const responder = store?.getState()?.auth?.user;
  const name = deriveDisplayName(responder);
  let data = {
    unitId: notif?.unit?.unitId,
    userId: notif?.sender?.id,
    eventName: eventName,
    alertArguments: `{'Name':'${name}','Unit':'${
      notif?.unit?.unitName
    }','Phonenumber':'${
      responder?.phone1
    }','SenderType':'person', 'Approver':'${name}','StartDate':'${
      notif?.dateFrame?.startDate || null
    }','EndDate':'${notif?.dateFrame?.endDate || null}'}`,
    // Image: responder.profilePicture,
    parentAlertId: notif?.alertId,
    action: response,
  };
  if (receiverType === 'person') {
    delete data.userId;
    data = {
      ...data,
      personId: notif?.sender?.id,
    };
  }
  try {
    const sendActionData = {
      alertDetailId: notif?.id,
      action: response,
    }
    console.log('sendActionData', sendActionData);
    // {"action": 1, "alertDetailId": "a1f81a45-70f7-4ee0-897b-8e3313e43525"}
//     {"action": null, "alertBackgroundColor": null, "alertId": "434A3BED-873F-4C04-A3CA-66AB379EEA0F", "appMessageHTML": null, "approval": null, "button1": {"text": "Authorize", "value": "1"}, "button2": {"text": "Do not Authorize", "value": "2"}, "button3": {"text": "Call", "value": "3"}, "dateFrame": null, "denial_Reason": "", "eventName": "VisitorScreen", "id": "a2a4c18b-84ce-4aae-a809-10d6220baa2e", "image": null, "message": "You have a Visitor!
// Cardholder Ima is at {AccessGate} and is requesting to visit your unit - 3409 {UnitName}.
// You can AUTHORIZE or DECLINE access,
//  Thank you.", "phoneNumber": null, "prevAlertId": null, "read": false, "receivedAt": 1764746756987, "sender": {"deviceName": null, "id": "1D0D969D-D1C4-4F44-B39B-EBCE668AE9EC", "image": null, "name": " ", "type": "User"}, "status": "Created", "time": "2025-12-03T10:25:56.987", "type": null, "unit": {"unitDisplay": "3409-Core", "unitId": "7AA43F8B-FE1E-444A-8885-3E95E12D9A0E", "unitName": "3409"}}
// {"action": 1, "alertDetailId": "9b203a9d-5ee6-4fdd-8875-1302f6247985"}
    await sendAction(sendActionData);
    await createAlert(data, receiverType);
  } catch (error) {
    showErrorMessage('configureNotifications: ' + error.message);
  }
};

export const handleIgnore = async (notif: Alert, response: number) => {
  try {
    const personUnitLinks: UnitLink[] = await fetchLinksByPerson(
      notif.sender.id,
    );
    const personLinkToUpdate: UnitLink = personUnitLinks.filter(
      (unitLink: UnitLink) => unitLink.unit.id === notif.unit.unitId,
    )[0];
    await updateUnitPeopleLink(personLinkToUpdate.id, {
      lInkApproved: 'Denied',
    });
    await buildResponseAlert(notif, response, 'UnitLinkDenied', 'person');
  } catch (error) {
    showErrorMessage('configureNotifications - 2: ' + error.message);
  }
};

export const handleAuthorize = async (notif: Alert, response: number) => {
  try {
    const personUnitLinks: UnitLink[] = await fetchLinksByPerson(
      notif.sender.id,
    );
    const personLinkToUpdate: UnitLink = personUnitLinks.filter(
      unitLink => unitLink.unit.id === notif.unit.unitId,
    )[0];

    //Create new dateFrame
    const dateFrame = {
      unitId: notif.unit.unitId,
      startDate: notif?.dateFrame.startDate,
      endDate: notif?.dateFrame.endDate,
      notes: notif?.dateFrame.description,
    };
    const newDateFrame = await createDateFrame(dateFrame);
    const dateFrameId = await newDateFrame.id;

    //Send response
    await sendAction({
      alertDetailId: notif?.id,
      action: response,
    });
    //Update person dateFrame
    await updatePersonDateFrames({
      unitPeopleLinkId: personLinkToUpdate.id,
      dateFrameIds: [dateFrameId],
      oneTimePass: isOneDayDateFrame(dateFrame.startDate, dateFrame.endDate),
    });

    //Send alert to people in unit and/or to requesting person
    await buildResponseAlert(notif, response, 'ResidentAccessApproved', 'person');
    // sendAlert(personLinkToUpdate, notif.sender.id, notif.unit.unitId);
} catch (error) {
    showErrorMessage('configureNotifications - 3: ' + error.message);
  }
};

export const sendAlert = async (
  unitPeopleLink: UnitLink,
  requestingPersonId: string,
  unitId: string,
) => {
  const approver = store?.getState()?.auth?.user;
  const requestingPerson = await fetchPerson(requestingPersonId);
  const personName = deriveDisplayName(requestingPerson);
  const approverName = deriveDisplayName(approver);
  const unit = await fetchUnitById(unitId);
  const unitName = unit.unit ? unit.unit : unit.unitDisplay;

  const alertArguments = `{'Name':'${personName}','Unit':'${unitName}','Approver':'${approverName}'}`;
  const personAlertArguments = `{'Unit':'${unitName}','Approver':'${approverName}'}`;

  if (unitPeopleLink) {
    if (unitPeopleLink.canManagePeople) {
      await createAlert(
        {
          alertArguments,
          eventName: 'UnitLinkApproved',
          unitId,
        },
        'person',
      );
    } else {
      await createAlert(
        {
          alertArguments,
          eventName: 'UnitLinkApproved',
          unitId,
        },
        'person',
      );
      await createAlert(
        {
          alertArguments: personAlertArguments,
          eventName: 'UnitLinkApprovedPerson',
          personId: requestingPerson.id,
        },
        'person',
      );
    }
  } else {
    await createAlert(
      {
        alertArguments: personAlertArguments,
        eventName: 'UnitLinkDenied',
        personId: requestingPerson.id,
      },
      'person',
    );
  }
  // showSuccessMessage('Request access processed successfully');
};

const processedAlertIds = new Set<string>();

export const handlePushyIncomingNotification = async (data: any) => {
  const alertId = data.Id || data.AlertId || data.id;
  if (alertId) {
    const normalizedId = alertId.toLowerCase();
    if (processedAlertIds.has(normalizedId)) {
      console.log(`[Pushy] Duplicate alert ignored in JS: ${normalizedId}`);
      return;
    }
    processedAlertIds.add(normalizedId);
    if (processedAlertIds.size > 100) {
      const firstEntry = processedAlertIds.values().next().value;
      processedAlertIds.delete(firstEntry);
    }
  }

  const deviceName = Device.deviceName ?? 'Unknown Device';
  console.log(`[Pushy] ${deviceName} Received notification:`, data.EventName, 'AlertId:', data.Id);

  if (Platform.OS === 'ios') {
    Vibration.vibrate();
  }

  if (Platform.OS === 'android' || (Platform.OS === 'ios' && AppState.currentState === 'active')) {
    const alert = buildAlertObject(data);
    await sendNotification(alert);
  }

  console.log('[Pushy] Dispatching ReceiveAlert action to send ACK...');
  store.dispatch(
    ReceiveAlert(data.Id, data.ParentAlertId, data.EventName, data.Action)
  );
  store.dispatch(GetApprovals());

  const eventName = data.EventName;
  const shouldReloadUnits =
    eventName?.startsWith('Welcome') ||
    eventName?.endsWith('Person') ||
    eventName === 'PeopleLinkApproved' ||
    eventName === 'LinkedWelcomeMessage';

  const shouldReloadPeople =
    eventName === 'RequestAccessApproved' || eventName === 'UnitLinkApproved';

  if (shouldReloadUnits) store.dispatch(GetUnitScreenData(true));
  if (shouldReloadPeople) store.dispatch(GetPeople());

  store.dispatch(DeleteAllApprovals());
  store.dispatch(GetApprovals());

  queryClient.invalidateQueries();
};

export const handlePushyNotificationClick = async (data: any) => {
  console.log('Notification clicked: ', data);
  if (Platform.OS === 'ios') {
    if (data.EventName === 'UnitLink' || data.EventName === 'RequestAccess') {
      store.dispatch(NavigateToApprovalDetails(data.Approval.Id));
    } else {
      store.dispatch(NavigateToDetails(data.AlertId));
    }
  }
};

export default configureNotifications;
